import _svgPanZoom from "./svg-pan-zoom.js";
var exports = {};
var SvgPanZoom = _svgPanZoom;
exports = SvgPanZoom;
export default exports;